import { Provider } from '@common/enums';
import { AuthUser } from '@common/models';

export function isHomeUser(user: AuthUser): boolean {
  return user?.Provider == Provider.OfficeHome || user?.Provider == Provider.GoogleHome;
}
